<template>
    <v-container>
        <v-row v-for="(berita, i) in listBerita" :key="i">
            <v-col>
                <v-card>
                    <v-card-title>{{ getDateFormattedDatefns(berita.createdAt) }}</v-card-title>
                    <v-card-title>{{ berita.title }}</v-card-title>
                    <v-card-text> <v-textarea class="text-body-2" v-model="berita.content" auto-grow readonly filled outlined /> </v-card-text>
                    <template v-if="berita.fileAttachment !== ''">
                        <v-card-actions>
                            <v-btn class="text-caption" color="primary" depressed @click="getLinkDownload(berita.fileAttachment)">
                                Attachment
                                <v-icon small>get_app</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </template>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>

const apiUrl = process.env.VUE_APP_ROOT_API
const axios = require('axios').default;
import { format } from 'date-fns'


export default {
    data() {
        return {
            listBerita: []
        }

    }, // data


    mounted() {
        this.getData();
    },


    methods: {
        getData() {
            this.listBerita = [];

            axios.get(`${apiUrl}/api/berita-informasi/B`)
            .then( (response) => {
                this.listBerita = response.data;

            }).catch( (error) => {
                console.error(error);
            });
        },

        getLinkDownload(dok) {
            axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
            .then(response => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = dok
                link.click()
                URL.revokeObjectURL(link.href)
            }).catch(console.error)
        },

        getDateFormattedDatefns: function(date) {
            return date ? format(Date.parse(date), "dd MMM yyyy") : ''
        },

    }, // methods
}

</script>
